export default function Products() {
  const categories = [
    {
      title: 'Computer & Laptop',
      description: 'Desktop, notebook e workstation per ogni esigenza professionale',
      image:
        'https://public.readdy.ai/ai/img_res/f3bb0f40b657b72e28d12fefb18bc7ca.jpg',
      badge: 'Novità',
      badgeColor: 'bg-orange-500',
    },
    {
      title: 'Componenti PC',
      description: 'Processori, schede madri, RAM, storage e periferiche',
      image:
        'https://readdy.ai/api/search-image?query=computer%20hardware%20components%20including%20processor%20CPU%20motherboard%20RAM%20memory%20modules%20and%20storage%20drives%20arranged%20on%20clean%20white%20surface%20with%20professional%20lighting%20showcasing%20modern%20PC%20parts%20technology&width=800&height=600&seq=product-components-wordart-002&orientation=landscape',
      badge: 'Best Seller',
      badgeColor: 'bg-blue-600',
    },
    {
      title: 'Networking',
      description: 'Router, switch, access point e soluzioni di rete',
      image:
        'https://readdy.ai/api/search-image?query=professional%20network%20equipment%20including%20router%20switch%20and%20access%20point%20devices%20with%20LED%20lights%20on%20clean%20white%20background%20showcasing%20modern%20networking%20technology%20and%20connectivity%20solutions&width=800&height=600&seq=product-networking-wordart-003&orientation=landscape',
      badge: 'Popolare',
      badgeColor: 'bg-green-600',
    },
    {
      title: 'Elettrodomestici',
      description: 'Grandi e piccoli elettrodomestici per la casa',
      image:
        'https://readdy.ai/api/search-image?query=modern%20home%20appliances%20including%20refrigerator%20washing%20machine%20and%20small%20kitchen%20appliances%20arranged%20in%20clean%20contemporary%20setting%20with%20white%20background%20highlighting%20sleek%20appliance%20design&width=800&height=600&seq=product-appliances-wordart-004&orientation=landscape',
      badge: 'Offerta',
      badgeColor: 'bg-red-500',
    },
    {
      title: 'Monitor & Display',
      description: 'Monitor professionali, TV e soluzioni di visualizzazione',
      image:
        'https://readdy.ai/api/search-image?query=professional%20computer%20monitor%20and%20large%20TV%20display%20screens%20showing%20vibrant%20colors%20on%20clean%20white%20desk%20in%20modern%20office%20setting%20highlighting%20display%20technology%20and%20visual%20quality&width=800&height=600&seq=product-monitors-wordart-005&orientation=landscape',
      badge: 'Nuovo',
      badgeColor: 'bg-purple-600',
    },
    {
      title: 'Accessori Tech',
      description: 'Tastiere, mouse, cuffie e accessori per computer',
      image:
        'https://readdy.ai/api/search-image?query=computer%20accessories%20including%20mechanical%20keyboard%20wireless%20mouse%20gaming%20headset%20and%20tech%20peripherals%20arranged%20on%20clean%20white%20surface%20with%20professional%20lighting%20showcasing%20modern%20technology%20accessories&width=800&height=600&seq=product-accessories-wordart-006&orientation=landscape',
      badge: 'Trend',
      badgeColor: 'bg-indigo-600',
    },
  ];

  return (
    <section id="prodotti" className="py-24 bg-gray-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-5xl font-black text-gray-900 leading-tight">
              I Nostri
              <span className="block text-orange-500">Prodotti</span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-lg text-gray-600 leading-relaxed">
              Scopri la nostra vasta gamma di prodotti tecnologici e
              elettrodomestici per il tuo business
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative w-full h-64 overflow-hidden bg-gray-100">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span
                    className={`${category.badgeColor} text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg`}
                  >
                    {category.badge}
                  </span>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors">
                  {category.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {category.description}
                </p>
                <button className="w-full border-2 border-orange-500 text-orange-500 px-6 py-3 rounded-full font-bold hover:bg-orange-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Scopri di Più
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
